// lib
import { styled } from '@nykaa/ui-components';

// mixin
import { truncate } from 'shared/styles/mixin/core';

// components
import Image from 'shared/components/ImageV2';

export const Product = styled.a<{ width: number; padding: number; isMobile: boolean }>`
  text-decoration: none;
  display: block;
  margin-right: ${({ isMobile, theme }) =>
    `${isMobile ? theme.spacing.spacing40 : theme.spacing.spacing100}`};
  width: ${({ width }) => `${width}px`};
  background-color: ${({ theme }) => theme.colors.snow100};
  padding: ${({ padding }) => `${padding}px`};
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  flex-shrink: 0;

  :first-of-type {
    margin-left: ${({ theme }) => theme.spacing.spacing80};
  }
`;

export const imgClassName = 'imageContain';

export const ProductImage = styled(Image)`
  display: block;

  &.${imgClassName} {
    background: #fff;
    object-fit: cover;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.div`
  ${truncate}

  ${({ theme }) => theme.typography.titleXSmall};
  height: 20px;
  font-style: normal;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const SubTitle = styled.div`
  ${truncate}

  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Description = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing40};
`;

export const ProductImageContainer = styled.div<{ containerWidth: number }>`
  display: flex;
  justify-content: center;
  &.big-image {
    ${({ theme }) => `margin-right: ${theme.spacing.spacing40}`}
  }
  ${({ containerWidth }) => `min-width: ${containerWidth}px`};
`;
